import { Box, SxProps } from "@mui/material";

type FlexCenterProps = {
    children: React.ReactNode;
    direction?: "column" | "row";
    sx?: SxProps;
};

export default function FlexCenter({ direction, children, sx}: FlexCenterProps) {
    return (
        <Box sx={sx} height="100%" display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={direction}>
            {children}
        </Box>
    );
}
